module.exports = __webpack_public_path__ + "img/home.35033fad.svg";